module.exports = __webpack_public_path__ + "img/MZ.3a028fbe.svg";